import { useRef } from 'react'
import { gsap, useGSAP } from '../lib/gsap'
import { useLang } from '../lib/useLang'
import { MANIFESTO, MARQUEE } from '../data/content'
import VelocityMarquee from '../components/VelocityMarquee'
import Logo from '../components/Logo'

// Each word lights up as it scrolls through the viewport; *highlights* resolve into the brand gradient.
export default function Manifesto() {
  const root = useRef(null)
  const { t, lang } = useLang()
  const text = t(MANIFESTO)

  const words = []
  text.split(/(\*[^*]+\*)/g).forEach((chunk) => {
    const hl = chunk.startsWith('*')
    chunk
      .replace(/\*/g, '')
      .split(/\s+/)
      .filter(Boolean)
      .forEach((w) => words.push({ w, hl }))
  })

  useGSAP(
    () => {
      gsap.fromTo(
        '[data-word]',
        { opacity: 0.12, filter: 'blur(4px)', y: 10 },
        {
          opacity: 1,
          filter: 'blur(0px)',
          y: 0,
          ease: 'none',
          stagger: 0.08,
          scrollTrigger: { trigger: '[data-words]', start: 'top 80%', end: 'bottom 45%', scrub: 0.6 },
        },
      )
      gsap.from('[data-mlogo]', {
        rotate: -120,
        scale: 0.4,
        opacity: 0,
        scrollTrigger: { trigger: root.current, start: 'top 85%', end: 'top 35%', scrub: 1 },
      })
    },
    { scope: root, dependencies: [lang], revertOnUpdate: true },
  )

  return (
    <section ref={root} className="relative overflow-hidden py-28 sm:py-40">
      <div className="mx-auto grid max-w-[1440px] gap-10 px-5 sm:px-10 lg:grid-cols-[180px_1fr]">
        <div className="flex items-start gap-3 lg:flex-col">
          <Logo data-mlogo className="h-10 w-10" />
          <span className="label mt-2 text-mist">(01) — Manifesto</span>
        </div>
        <p data-words className="font-display text-[clamp(1.75rem,4.2vw,4rem)] font-medium leading-[1.12] tracking-[-0.025em]">
          {words.map(({ w, hl }, i) => (
            <span key={`${lang}-${i}`} data-word className={`mr-[0.25em] inline-block ${hl ? 'text-gradient' : 'text-white'}`}>
              {w}
            </span>
          ))}
        </p>
      </div>
      <div className="mt-24 flex flex-col gap-2 sm:mt-36">
        <VelocityMarquee items={MARQUEE} />
        <VelocityMarquee items={[...MARQUEE].reverse()} reverse outline baseSpeed={30} />
      </div>
    </section>
  )
}
